import coreJSWithResolvers from 'core-js-pure/features/promise/with-resolvers.js';

export default function withResolvers() {
  return coreJSWithResolvers();
}
